<template>
  <section class='home_page'>
    <div class='background' :style="{backgroundImage: 'url('+require('../assets/img/background.png')+')'}"></div>
    <!-- <video class='background' type='mov' loop autoplay muted src='../assets/img/background.mov'></video> -->
   <header>
     <p>Welcome to the New York</p>
      <img src='../assets/img/logo.svg'>
    </header>
   <transition name='fade_slide'>
    <div v-if='step == "step1"' class="contain">
        <h1 :class="{show: showTitle}">The Company of The Future is Bionic</h1> 
        <img @click='nextStep("step2")' :class="{show_wheel: showWheel}" class='wheel' src='../assets/img/wheel.png'>
        <div class='launch' :class="{show: showLaunch}">
          <p class='intro'>Experience what makes a company bionic</p>
          <div @click='nextStep("step2")' class='btn'>
            <div>
              <p>Launch Experience </p>
              <img class='arr' src='../assets/img/arr.svg'>
            </div>
          </div>
        </div>
      </div>
   </transition>

   <transition name='fade_slide'>
    <div v-if='step == "step2"' class="contain step2">
        <h1 :class="{show: showTitle}">What is aBionic Company?</h1>  
        <div class='launch' :class="{show: showLaunch}" @click='removePopup()'>
          <p><strong>Bionic Companies</strong> successfully blend new technologies with human and organizational capabilities to power growth, innovation, efficiency, resilience, and advantage.</p>
          <p class='bold_center'>Bionic processes are the backbone of the company of the future</p>
          <p>These processes are very different from what companies are accustomed to. Now people operate processes, but in the future they will put their efforts into the design of processes—from simple to complex—that will be digitally augmented or automated. </p>
          <p @click='addPopup()' class='text_btn' :class="{no_delay: popup}">What is Bionic? <img src='../assets/img/arr_blue.svg'></p>
          <transition name='fade-fast'>
            <div v-if='popup' class='moreinfo'>
              <p class='close'>x</p>
              <div @click='addPopup()'>
                <p class='title'>What is Bionic?</p>
                <p>Bionics or biologically inspired engineering is the application of biological methods and systems found in nature to the study and design of engineering systems and modern technology. The word bionic was coined by Jack E. Steele in August 1958, being formed as a portmanteau from biology and electronics.</p>
              </div>
            </div>
          </transition>
          <v-select
          class='choose_sector'
          :class="{no_shake: !shake}"
          v-model="sector"
          :searchable="false"
          :options='sectors'>
          </v-select>
          <transition name='fade'>
            <div v-if='sector != "Select a Sector Here..."' @click='nextStep("step3")' class='btn sector_btn'>
              <div>
                <p>Activate Sector</p>
                <img class='arr' src='../assets/img/arr.svg'>
              </div>
            </div>
          </transition>
        </div>
      </div>
   </transition>

   <transition name='fade_slide'>
    <div v-if='step == "step3"' class="contain">
        <h1 :class="{show: showTitle}">Sector Activated!</h1>  
        <div class='launch' :class="{show: showLaunch}">
          <p class='bold_center'>Proceed to the screen on your left to experience the “The Bionic Company” of the future</p>
          <svg class='arrows' width="1080" height="352" viewBox="0 0 1080 352">
            <path class='arr arr1' d="M-90.84,254.72l144,160A16.23,16.23,0,0,0,65.07,420h96A16,16,0,0,0,173,393.28L38.6,244,173,94.69A16,16,0,0,0,161.07,68h-96a16,16,0,0,0-11.91,5.32l-144,160A16,16,0,0,0-90.84,254.72Z" transform="translate(94.94 -68)" style="fill: #fff"/>
            <path class='arr arr2' d="M119.16,254.72l144,160A16.23,16.23,0,0,0,275.07,420h96A16,16,0,0,0,383,393.28L248.6,244,383,94.69A16,16,0,0,0,371.07,68h-96a16,16,0,0,0-11.91,5.32l-144,160A16,16,0,0,0,119.16,254.72Z" transform="translate(94.94 -68)" style="fill: #fff"/>
            <path class='arr arr3' d="M327.16,254.72l144,160A16.23,16.23,0,0,0,483.07,420h96A16,16,0,0,0,591,393.28L456.6,244,591,94.69A16,16,0,0,0,579.07,68h-96a16,16,0,0,0-11.91,5.32l-144,160A16,16,0,0,0,327.16,254.72Z" transform="translate(94.94 -68)" style="fill: #fff"/>
          </svg>
        </div>
      </div>
   </transition>

    <div class='qr_holder'>
      <p>For Center bookings and information, please contact  Immersion Center Manager Sasha Engel</p>
      <img src='../assets/img/qr.png'>
    </div>

    <!-- <transition name='fade'>
      <div 
        v-if='popup'
        class='popup'>
        <div @click='popup = false' class='offclick'></div>
        <p @click='popup = false' class='close close_top'>x</p>
        <div class='holder'>
          <h1 :class="{show: popup}">What is Bionic?</h1> 
          <p>Bionics or biologically inspired engineering is the application of biological methods and systems found in nature to the study and design of engineering systems and modern technology. The word bionic was coined by Jack E. Steele in August 1958, being formed as a portmanteau from biology and electronics.</p> 
        </div>
        <p @click='popup = false' class='close close_bottom'>x</p>
      </div>
    </transition> -->
  </section>
</template>

<script>
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "home",
  data(){
    return {
      popup: false,
      dots: false,
      shake: true,
      showTitle: false,
      showWheel: false,
      showLaunch: false,
      step: "step1",
      sector: 'Select a Sector Here...',
      sectors: ['CPG', 'Other Sectors coming soon'],
      activations: null,
      initial: false,
      holdPopup: false
    }
  },
  mounted(){
    this.$nextTick(function(){
      this.animate();
    });
  },
  created(){
    let vm = this;
    db.collection("activation")
    .orderBy('created', 'desc')
    .onSnapshot(function(doc) {
        vm.activations = doc.docs.map(obj => obj.data());
    });
  },
  methods: {
    addPopup(){
      this.holdPopup = true;
      setTimeout(()=>{
        this.popup = true;
        this.holdPopup = false;
      }, 200);
    },
    removePopup(){
      this.shake = false;
      setTimeout(()=>{
        if (this.popup && !this.holdPopup) {
          this.popup = false;
        }
      }, 100);
    },
    animate(){
      let vm = this;
      setTimeout(function(){
        vm.showTitle = true;
      }, 500);
      setTimeout(function(){
        if (vm.step == "step2" || vm.step == "step3") {
          vm.showLaunch = true;
          if (vm.step == "step3") {
            setTimeout(()=>{
              vm.dots =true;
            }, 500);
          }
        }else {
          vm.showWheel = true;
        }
      }, 1500);
      setTimeout(function(){
        vm.showLaunch = true;
      }, 2500);
    },
    nextStep(step) {
      let vm = this;
      this.step = null;
      this.showTitle= false;
      this.showWheel= false;
      this.showLaunch= false;
      setTimeout(function(){
        vm.step = step;
        vm.animate();
      }, 1000);
    }
  },
  watch: {
    step(){
      let vm = this;
      if (this.step == "step3") {
        db.collection('activation').doc()
        .set({sector: this.sector, created: Date.now()})
        .then(()=>{

        })
        .catch((err)=>{
          alert('Failed to connect!')
        });
      }
    },
    activations(){
        let vm = this;
        // if (this.activations[0])
        if (this.initial) {
          if (this.activations[0].complete){
            this.nextStep('step1');
          }
        }

        if (!moment(this.activations[0].created).isAfter(Date.now)){
            this.initial = true;
        }
        
    }
    
  }
}
</script>

<style lang="css">
</style>
